import Vue from 'vue'
import VueCookie from 'vue-cookie'
import handleNav from './nav'
import lazyLoadImages from './lazy-load-images'
import Flickity from 'flickity'
import 'flickity-imagesloaded'
import CookieBanner from './_vue/components/CookieBanner'

Vue.use(VueCookie)

new Vue({
    el: '#app',
    delimiters: ['${', '}'],
    // Register the above-imported components.
    components: {
        'cookie-banner': CookieBanner
    },
    mounted() {
        handleNav()
        lazyLoadImages()
        var heroCarousel = document.querySelector('.hero--carousel > div')
        if (heroCarousel) {
            var flkty = new Flickity(heroCarousel, {
                autoPlay: 3000,
                cellSelector: '.hero--carousel-slide',
                imagesLoaded: true,
                prevNextButtons: false,
                lazyLoad: 2
            })
            flkty.on('resize', function() {
                var isSingleSlide = flkty.slides.length < 2
                heroCarousel.classList.toggle('is-single-slide', isSingleSlide)
            })
            flkty.resize()
        }
    }
})
